module.exports = __webpack_public_path__ + "static/media/plus.e8ce115e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/plus.svg
// module id = 138
// module chunks = 0